import { Record } from 'immutable';

export const QuestionnaireDataStoreOptions = new Record({
    isNew: true,
    isPending: false,
    error: null,
    options: []
    
});
